import { Location } from 'history'

const SSO_REDIRECT_LOCATION_KEY = 'extend:sso-redirect-location'

const isInternalLocation = (location: string): boolean =>
  location.startsWith('/') && !location.startsWith('//')

export const persistSsoRedirectLocation = (location: Location): void => {
  if (typeof window === 'undefined') return

  const redirectLocation = `${location.pathname}${location.search}${location.hash}`
  if (!isInternalLocation(redirectLocation)) return

  try {
    window.sessionStorage.setItem(SSO_REDIRECT_LOCATION_KEY, redirectLocation)
  } catch {
    // Continue to SSO when browser storage is unavailable.
  }
}

export const consumeSsoRedirectLocation = (): string | undefined => {
  if (typeof window === 'undefined') return undefined

  try {
    const redirectLocation = window.sessionStorage.getItem(
      SSO_REDIRECT_LOCATION_KEY,
    )
    window.sessionStorage.removeItem(SSO_REDIRECT_LOCATION_KEY)

    return redirectLocation && isInternalLocation(redirectLocation)
      ? redirectLocation
      : undefined
  } catch {
    return undefined
  }
}
